import React from 'react';
import { Helmet } from 'react-helmet';

const SITE_NAME = 'Rent Utopia';
const SITE_URL = 'https://utopia.pegasus-pms.co.ke';
const DEFAULT_DESCRIPTION = 'Find your perfect rental home in Kenya. Browse verified listings, connect with landlords, and manage your rental journey with Rent Utopia.';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

/**
 * Reusable per-page SEO tags (title, meta description, canonical, Open Graph,
 * Twitter Card, optional JSON-LD). Modeled on the existing Helmet usage in
 * PropertyManagement.jsx, generalized for use across the site.
 */
const SEO = ({
    title,
    description = DEFAULT_DESCRIPTION,
    canonicalPath = '',
    image = DEFAULT_IMAGE,
    noindex = false,
    jsonLd = null
}) => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    const canonicalUrl = `${SITE_URL}${canonicalPath}`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
            <link rel="canonical" href={canonicalUrl} />

            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:type" content="website" />
            <meta property="og:image" content={image} />
            <meta property="og:site_name" content={SITE_NAME} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {jsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
export { SITE_NAME, SITE_URL, DEFAULT_DESCRIPTION };
